/* eslint-disable import/no-unresolved */
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'
import animatedScrollTo from 'https://cdn.skypack.dev/animated-scroll-to'
/* eslint-enable */

const { config } = window.BAO.Carousel
const { setInitialised, useDots } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide', 'button']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.config.elements.mediaImages.forEach(mediaImageEl => {
      this.pinchZoom(mediaImageEl)
    })

    if (this.els?.button?.exists) {
      this.els.button.elements.forEach(button => {
        this.listeners.add(button, 'click', this.toggleDesktopZoom.bind(this))
      })
    }

    document.addEventListener('click', e => {
      if (
        !document.body.classList.contains(this.config.classes.desktopZoomClass)
      ) {
        return
      }

      if (e?.target?.dataset?.productMediaEl === 'button') return

      document.body.classList.remove(this.config.classes.desktopZoomClass)

      const originalMediaHeight = this.els.slides.element.offsetHeight
      const originalOffset = window.pageYOffset
      const offsetFactor = originalOffset / originalMediaHeight

      const newMediaHeight = document.body.classList.contains(
        this.config.classes.desktopZoomClass,
      )
        ? originalMediaHeight * 2
        : originalMediaHeight / 2
      const newOffset = newMediaHeight * offsetFactor

      const easing = document.body.classList.contains(
        this.config.classes.desktopZoomClass,
      )
        ? this.config.easing.easeIn
        : this.config.easing.easeOut

      this.setMediaPosition(newOffset, easing)
    })
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 1,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
        slideChanged: this.onSlideChanged,
      },
      [setInitialised(), useDots(this.els.dot.elements)],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.classList.toggle(
        this.config.classes.mediaSlideActiveClass,
        index === currentSlide,
      )
    })
  }

  pinchZoom (imageElement) {
    this.imageElementScale = 1
    this.isScaled = false

    this.singleTouchX = 0
    this.singleTouchY = 0

    const start = {}

    // Calculate distance between two fingers
    const distance = event => {
      return Math.hypot(
        event.touches[0].pageX - event.touches[1].pageX,
        event.touches[0].pageY - event.touches[1].pageY,
      )
    }

    document.body.addEventListener(
      'touchstart',
      event => {
        if (event.target === imageElement) {
          if (event.touches.length === 2) {
            event.preventDefault() // Prevent page scroll

            // Calculate where the fingers have started on the X and Y axis
            start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2
            start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2
            start.distance = distance(event)

            document.body.classList.add(
              this.config.classes.pinchZoomActiveClass,
            )

            const initialTransformValue = document.querySelector(
              this.config.matches.mediaSlideActive,
            ).style.transform
            document.documentElement.style.setProperty(
              '--initial-transform',
              initialTransformValue,
            )
          }
        }
      },
      { passive: true },
    )

    imageElement.addEventListener(
      'touchmove',
      event => {
        if (event.touches.length === 2) {
          event.preventDefault() // Prevent page scroll

          this.isScaled = true

          // Safari provides event.scale as two fingers move on the screen
          // For other browsers just calculate the scale manually
          let scale
          if (event.scale) {
            scale = event.scale
          } else {
            const deltaDistance = distance(event)
            scale = deltaDistance / start.distance
          }
          this.imageElementScale = Math.min(Math.max(1, scale), 4)

          // Calculate how much the fingers have moved on the X and Y axis
          this.deltaX =
            ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) *
            2 // x2 for accelarated movement
          this.deltaY =
            ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) *
            2 // x2 for accelarated movement

          // Transform the image to make it grow and move with fingers
          const transform = `translateX(${this.deltaX}px) translateY(${this.deltaY}px) scale(${this.imageElementScale})`
          imageElement.style.transform = transform
          imageElement.style.WebkitTransform = transform
        }

        if (event.touches.length === 1 && this.isScaled === true) {
          event.preventDefault() // Prevent page scroll

          const movementX = event.touches[0].pageX - this.singleTouchX
          const movementY = event.touches[0].pageY - this.singleTouchY

          const newX = this.deltaX + movementX
          const newY = this.deltaY + movementY

          const transform = `translateX(${newX}px) translateY(${newY}px) scale(${this.imageElementScale})`
          imageElement.style.transform = transform
          imageElement.style.WebkitTransform = transform
        }
      },
      { passive: true },
    )

    imageElement.addEventListener(
      'touchend',
      event => {
        if (event.touches.length === 1) {
          this.singleTouchX = event.touches[0].pageX
          this.singleTouchY = event.touches[0].pageY
        }

        if (event.touches.length === 0) {
          // Reset image to it's original format
          imageElement.style.transform = ''
          imageElement.style.WebkitTransform = ''

          document.body.classList.remove(
            this.config.classes.pinchZoomActiveClass,
          )

          this.isScaled = false
        }
      },
      { passive: true },
    )
  }

  toggleDesktopZoom (e) {
    document.body.classList.toggle(this.config.classes.desktopZoomClass)

    const imageElements = document.querySelectorAll(
      this.config.matches.originalImages,
    )

    if (imageElements !== null) {
      // Swap images to master image
      imageElements.forEach(imageElement => {
        imageElement.src = imageElement.closest(
          this.config.matches.media,
        ).dataset.masterSrc
        imageElement.srcset = ''
        imageElement.classList.add(this.config.classes.masterImageClass)
      })
    }

    const originalMediaHeight = this.els.slides.element.offsetHeight
    const originalOffset = window.pageYOffset
    const offsetFactor = originalOffset / originalMediaHeight

    const newMediaHeight = document.body.classList.contains(
      this.config.classes.desktopZoomClass,
    )
      ? originalMediaHeight * 2
      : originalMediaHeight / 2
    const newOffset = newMediaHeight * offsetFactor

    const easing = document.body.classList.contains(
      this.config.classes.desktopZoomClass,
    )
      ? this.config.easing.easeIn
      : this.config.easing.easeOut

    this.setMediaPosition(newOffset, easing)
  }

  setMediaPosition (scrollToPosition, easing) {
    const options = {
      maxDuration: 250,
      minDuration: 250,
      easing,
    }

    animatedScrollTo(scrollToPosition, options)
  }

  get config () {
    return {
      matches: {
        media: '.pz-Media',
        mediaSlideActive: '.prd-Media_Slide-active',
        mediaImages:
          '.prd-Media_Slide .rsp-Image_Image:not(.rsp-Image_Image-master)',
        originalImages:
          '.prd-Media_Slides .prd-Media_Slide:not(.prd-Media_Slide-desktopHide) .rsp-Image_Image:not(.rsp-Image_Image-master)',
      },
      classes: {
        pinchZoomActiveClass: 'lyt-Site-pinchZoomActive',
        mediaSlideActiveClass: 'prd-Media_Slide-active',
        desktopZoomClass: 'lyt-Site-desktopZoomActive',
        masterImageClass: 'rsp-Image_Image-master',
      },
      elements: {
        mediaImages: document.querySelectorAll(
          '.pz-Media .rsp-Image_Image:not(.pz-Image)',
        ),
      },
      easing: {
        easeIn: t => t,
        easeOut: t => t,
      },
    }
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
